<template>
  <v-container>
    <div class="d-flex text-center flex-column flex-md-row flex-grow-1">
    <div class="pa-2 pa-md-4 flex-grow-1 align-center justify-center d-flex flex-column">
      <div class="layout-content ma-auto w-full">
    <template v-if="authState === 'signedin' && user">
    <v-card id="pfid1618854647">
      <v-card-title  class="justify-center display-1 mb-2">{{$t('profile.title')}}</v-card-title>
      <v-card-text clas="align-left justify-left">{{$t('profile.text', { user: user.attributes.email})}}</v-card-text>
      <v-card-actions>
        <!--
        <amplify-sign-out></amplify-sign-out>
        -->
        <v-btn id="pfid1618854623" text color="primary" @click="logout">{{$t('toolbar.logOut')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card id="pfid1618854692" class="mt-3 pa-2">
    <v-card-title class="justify-center display-1 mb-2">{{$t('profile.changePassword.title')}}</v-card-title>
    
    <v-alert type="error" colored-border border="left" v-if="error">
      {{ errorNewPasswordMessage }}
    </v-alert>
    <v-text-field
      id="pfid1618854652" 
      v-model="oldPassword"
      :append-icon="showPassword ? '$showPassword' : '$hidePassword'"
      :rules="[rules.required]"
      :type="showPassword ? 'text' : 'password'"
      :error="errorOldPassword"
      :error-messages="errorOldPasswordMessage"
      name="password"
      :label="$t('profile.changePassword.oldPass')"
      @change="resetErrors"
      @click:append="showPassword = !showPassword"
    ></v-text-field>
    <v-text-field
      id="pfid1618854658" 
      v-model="newPassword"
      :append-icon="showPassword ? '$showPassword' : '$hidePassword'"
      :rules="[rules.required]"
      :type="showPassword ? 'text' : 'password'"
      :error="errorNewPassword"
      :error-messages="errorNewPasswordMessage"
      name="password"
      :label="$t('profile.changePassword.newPass')"
      @change="resetErrors"
      @keyup.enter="confirmPasswordReset"
      @click:append="showPassword = !showPassword"
    ></v-text-field>
    <v-card-actions>
    <v-btn
      id="pfid1618854666" 
      :loading="isLoading"
      color="primary"
      text
      @click="confirmPasswordReset"
    >{{$t('profile.changePassword.action')}}</v-btn>
    </v-card-actions>
  </v-card>

    </template>
        </div>
    </div>
    </div>
</v-container>
</template>

<script>

import { mapState } from "vuex";

export default {
  name: 'Profile',
  data: () => ({
    isLoading: false,

      showNewPassword: false,
      newPassword: null,
      oldPassword: null,

      // form error
      errorNewPassword: false,
      errorNewPasswordMessage: '',
      errorOldPassword: false,
      errorOldPasswordMessage: '',

      // show password field
      showPassword: false,
      error: null,

      // input rules
      rules: {
        required: (value) => (value && Boolean(value)) || 'Required'
      }
  }),
  computed: {
    ...mapState('auth', ['user', 'authState'])
  },
  methods: {
    async confirmPasswordReset() {
      this.isLoading = true
      try {
        await this.$store.dispatch('auth/changePassword', { oldPassword: this.oldPassword, newPassword: this.newPassword });
        this.isLoading = false;
      } catch(e) {
        this.isLoading = false;
        this.error = true;
        console.error('error changing password', e);
        this.errorNewPasswordMessage = e;
      }
    },
    resetErrors() {
      this.errorOldPassword = false;
      this.errorOldPasswordMessage = '';
      this.errorNewPassword = false
      this.errorNewPasswordMessage = '';
    },
    async logout() {
      await this.$store.dispatch('auth/signOut');
      this.$router.go();
    }
  }
}

</script>

